module.exports = __webpack_public_path__ + "img/busca-avancada-plantas-forrageiras-2.c4dd54f9.jpg";